module.exports = {
	"eloan": {
		"company_name": "Eloan",
		"copyright": "Eloan is a Division of Banco Popular de Puerto Rico",
		"currency_symbol": "$",
		"customer_applications": {
			"additional_message": {
				"incomplete": null,
				"review": "<strong>Thank you for submitting your application. There is nothing else that you need to do at this time.</strong> Our customer service specialists are reviewing the information that you’ve provided and will contact you if anything else is needed."
			},
			"customer_application_heading": {
				"false": "Action Required",
				"true": "In Review"
			},
			"listing": {
				"closed": "Recently Closed Applications",
				"open": "Applications"
			},
			"next_steps": {
				"additional_information": "Provide additional information",
				"bank_account": "Input bank information",
				"completed": "Complete outstanding tasks",
				"contract": "Sign contract",
				"null": "Finish initial application",
				"payment_details": "Provide payment information",
				"personal": "Finish initial application",
				"rates_terms": "Choose a loan option",
				"verification": "Complete outstanding tasks"
			}
		},
		"external_review": {
			"company_name": "CreditKarma"
		},
		"llc_name": "Eloan, Inc.",
		"product": {
			"alert": {
				"copy": {
					"late": "Pay now to get current on your loan",
					"paid_off": "No more payments need to be made on this loan.",
					"charged_off": "Your account has been sold to %{debt_buyer}. Please contact them at %{debt_buyer_phone}. In case you have already sent payment to %{ company_name }, the payment will be forwarded to %{ debt_buyer }."
				},
				"cta": "Make a Payment",
				"heading": {
					"charged_off": null,
					"late": "Loan Past Due",
					"paid_off": "Loan Paid Off"
				}
			},
			"is_autopay": {
				"true": "On",
				"false": "Off"
			},
			"payment": {
				"amount": "Amount",
				"next_payment": "Next Payment"
			},
			"progress": {
				"principal_paid": "Principal loan amount paid as of today"
			},
			"summary": {
				"headline": {
					"regions": "Your Regions loan application and closing process are complete."
				},
				"copy": {
					"regions": "<p>Please check your email inbox for confirmation of your loan closing and don’t forget to save a copy of your Regions Account Agreement for your records.</p><p>If your loan funds are direct deposited to your bank account, funding will occur on your loan closing date in most cases. However, if your loan closing date occurs on a weekend or bank holiday, it could take up to 3 days for funds to be processed on your account. If your loan is disbursed by check, it could take up to 3 days for the check to be issued. Please contact 800-734-4667 for funding questions or concerns.</p>"
				}
			},
			"tooltip": "Payments will be applied first to outstanding charges, if any, then to accrued interest and then to principal. Over time, as you continue to make payments, the allocation of your payment shifts so that the amount going towards interest will decrease.",
			"types": {
				"installment": "Personal Loan",
				"refinance": "Refinance"
			}
		},
		"product_owners": {
			"avantcredit": "%{company_name}",
			"regions": "Regions",
			"webbank": "Webbank"
		},
		"support_link": null,
		"support_number": "855-854-9346",
		"support_url": "http://support.avant.com"
	},
	"en-GB": {
		"company_name": "AvantCredit",
		"currency_symbol": "£",
		"support_link": null,
		"support_number": "0800 610 1516",
		"support_url": "http://support.avantcredit.co.uk"
	},
	"en-US": {
		"currency_symbol": "$",
		"product": {
			"alert": {
				"bad_bank_action": "Update Bank Account",
				"cta": "Make a Payment",
				"heading": {
					"late": "Loan Past Due.",
					"paid_off": "Loan Paid Off",
					"charged_off": null,
					"current": "There is an issue with your bank account on file."
				},
				"message": {
					"late": "Pay your past due amount of %{currencySymbol}%{pastDueAmount}.",
					"paid_off": "No more payments need to be made on this loan.",
					"payoff_pending": "Your total loan balance of %{currencySymbol}%{payoffAmount} is scheduled to be paid off on %{payoffDate}. No further action is required.",
					"payoff_pending_paper_check": "Please mail a check with your payment of %{currencySymbol}%{payoffAmount} by %{payoffDate} to pay off your loan. We've sent you an email with more details.",
					"charged_off": "Your account has been sold to %{debt_buyer}. Please contact them at %{debt_buyer_phone}. In case you have already sent payment to %{ company_name }, the payment will be forwarded to %{ debt_buyer }.",
					"late_bad_bank": "Please update your bank account and pay your past due amount of $%{pastDueAmount}.",
					"current_bad_bank_opted_in": "Please update your payment information today."
				},
				"support_number": {
					"late": "Please Call (844) 411-6053",
					"current": "Please Call (800) 712-5407",
					"paid_off": "Please Call (800) 712-5407"
				}
			},
			"credit_card_account": {
				"current_balance": "Current Balance",
				"available_credit": "Available Credit"
			},
			"is_autopay": {
				"true": "On",
				"false": "Off"
			},
			"payment": {
				"next_payment": "Next Payment",
				"amount": "Amount"
			},
			"progress": {
				"principal_paid": "Principal Paid"
			},
			"summary": {
				"headline": {
					"regions": "Your Regions loan application and closing process are complete."
				},
				"copy": {
					"regions": "<p>Please check your email inbox for confirmation of your loan closing and don’t forget to save a copy of your Regions Account Agreement for your records.</p><p>If your loan is direct deposited to your Regions' bank account, funding will occur on your loan closing date in most cases. However, if your loan closing date occurs on a weekend or bank holiday, or if you choose to have your loan direct deposited into a non-Regions bank account, it could take up to 3 days for funds to be processed on your account. If your loan is disbursed by check, it could be between three and five business days to receive the proceeds. Please contact 800-734-4667 for funding questions or concerns.</p>"
				}
			},
			"tooltip": "Payments will be applied first to outstanding charges, if any, then to accrued interest and then to principal. Over time, as you continue to make payments, the allocation of your payment shifts so that the amount going towards interest will decrease.",
			"types": {
				"credit_card": "AvantCard",
				"installment": "Personal Loan",
				"refinance": "Refinance"
			}
		},
		"support_link": "https://support.avant.com/article/234-how-can-i-contact-avant",
		"support_number": "800-712-5407",
		"support_url": "http://support.avant.com",
		"customer_applications": {
			"additional_message": {
				"incomplete": null,
				"review": "<strong>Thank you for submitting your application. There is nothing else that you need to do at this time.</strong> Our customer service specialists are reviewing the information that you’ve provided and will contact you if anything else is needed."
			},
			"credit_card_next_steps": {
				"personal": "Finish initial application",
				"personal_continued": "Finish initial application",
				"rates_terms": "Confirm your information",
				"verification": "Complete outstanding tasks"
			},
			"customer_application_heading": {
				"false": "Action Required",
				"true": "In Review"
			},
			"listing": {
				"closed": "Recently Closed Applications",
				"open": "Applications"
			},
			"next_steps": {
				"additional_information": "Provide additional information",
				"bank_account": "Input bank information",
				"contract": "Sign contract",
				"null": "Finish initial application",
				"payment_details": "Provide payment information",
				"personal": "Finish initial application",
				"rates_terms": "Choose a loan option",
				"verification": "Complete outstanding tasks"
			}
		},
		"company_name": "Avant",
		"copyright": "© Copyright 2016 Avant, LLC. All rights reserved.",
		"external_review": {
			"company_name": "CreditKarma"
		},
		"llc_name": "Avant, LLC",
		"product_owners": {
			"avantcredit": "%{company_name}",
			"regions": "Regions",
			"webbank": "Webbank"
		}
	},
	"hsbc": {
		"company_name": "HSBC"
	},
	"pnc": {
		"company_name": "PNC"
	},
	"regions": {
		"company_name": "Regions Bank",
		"product": {
			"summary": {
				"copy": {
					"regions": "<p>Please check your email inbox for confirmation of your loan closing and don’t forget to save a copy of your Regions Account Agreement for your records.</p><p>If your loan funds are direct deposited to your bank account, funding will occur on your loan closing date in most cases. However, if your loan closing date occurs on a weekend or bank holiday, it could take up to 3 days for funds to be processed on your account. If your loan is disbursed by check, it could take up to 3 days for the check to be issued. Please contact 800-734-4667 for funding questions or concerns.</p>"
				},
				"headline": {
					"regions": "Your Regions loan application and closing process are complete."
				}
			}
		}
	},
	"td": {
		"company_name": "TD",
		"copyright": "TDBank",
		"currency_symbol": "$",
		"customer_applications": {
			"additional_message": {
				"incomplete": null,
				"review": "<strong>Thank you for submitting your application. There is nothing else that you need to do at this time.</strong> Our customer service specialists are reviewing the information that you’ve provided and will contact you if anything else is needed."
			},
			"customer_application_heading": {
				"false": "Action Required",
				"true": "In Review"
			},
			"listing": {
				"closed": "Recently Closed Applications",
				"open": "Applications"
			},
			"next_steps": {
				"additional_information": "Provide additional information",
				"bank_account": "Input bank information",
				"completed": "Complete outstanding tasks",
				"contract": "Sign contract",
				"null": "Finish initial application",
				"payment_details": "Provide payment information",
				"personal": "Finish initial application",
				"rates_terms": "Choose a loan option",
				"verification": "Complete outstanding tasks"
			}
		},
		"llc_name": "TD Bank",
		"product": {
			"alert": {
				"copy": {
					"late": "Pay now to get current on your loan",
					"paid_off": "No more payments need to be made on this loan.",
					"charged_off": "Your account has been sold to %{debt_buyer}. Please contact them at %{debt_buyer_phone}. In case you have already sent payment to %{ company_name }, the payment will be forwarded to %{ debt_buyer }."
				},
				"cta": "Make a Payment",
				"heading": {
					"late": "Loan Past Due",
					"paid_off": "Loan Paid Off",
					"charged_off": null
				}
			},
			"is_autopay": {
				"false": "Off",
				"true": "On"
			},
			"payment": {
				"amount": "Amount",
				"next_payment": "Next Payment"
			},
			"progress": {
				"principal_paid": "Principal loan amount paid as of today"
			},
			"summary": {
				"headline": {
					"regions": "Your Regions loan application and closing process are complete."
				},
				"copy": {
					"regions": "<p>Please check your email inbox for confirmation of your loan closing and don’t forget to save a copy of your Regions Account Agreement for your records.</p><p>If your loan funds are direct deposited to your bank account, funding will occur on your loan closing date in most cases. However, if your loan closing date occurs on a weekend or bank holiday, it could take up to 3 days for funds to be processed on your account. If your loan is disbursed by check, it could take up to 3 days for the check to be issued. Please contact 800-734-4667 for funding questions or concerns.</p>"
				}
			},
			"tooltip": "Payments will be applied first to outstanding charges, if any, then to accrued interest and then to principal. Over time, as you continue to make payments, the allocation of your payment shifts so that the amount going towards interest will decrease.",
			"types": {
				"installment": "Personal Loan",
				"refinance": "Refinance"
			}
		},
		"product_owners": {
			"avantcredit": "%{company_name}",
			"webbank": "Webbank",
			"regions": "Regions",
			"td": "TD Fit"
		},
		"support_link": null,
		"support_number": "1-877-300-4030",
		"support_url": "http://support.tdfitloan.com"
	}
};